import {
  OplAddressCity,
  OplAddressStreet,
  OplAddressZipCode
} from "@closerplatform/spinner-openapi";
import { logger } from "@fidget/common/utils";
import { ForeSpinnerService } from "../../../services/spinnerService";

export const getCities = async (city: string): Promise<OplAddressCity[]> => {
  try {
    return ForeSpinnerService.getInstance().getOplAddressCities({ html: city });
  } catch (error) {
    logger.error({ message: "Couldn't fetch cities in address form", error });
    return [];
  }
};

export const getStreets = async (street: string, cityId: number): Promise<OplAddressStreet[]> => {
  try {
    return ForeSpinnerService.getInstance().getOplAddressStreets({
      filter: { city_id: cityId },
      html: street
    });
  } catch (error) {
    logger.error({ message: "Couldn't fetch streets in address form", error });
    return [];
  }
};

export const getZipCodes = async (
  streetNumber: string,
  streetId: number,
  cityId: number
): Promise<OplAddressZipCode[]> => {
  try {
    return ForeSpinnerService.getInstance().getOplAddressZipCodes({
      streetNumber,
      streetId,
      cityId
    });
  } catch (error) {
    logger.error({ message: "Couldn't fetch zip codes in address form", error });
    return [];
  }
};
